var exports = {
  "k": "x43aef4ae--71f667--container",
  "A": "x43aef4ae--71f667--item",
};

module.exports = exports;
